import type { GetFailedInvoiceDeliveriesReportResponsePayload } from '@vy/api-definition';
import { GetFailedInvoiceDeliveriesReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useFailedInvoiceDeliveriesReport(
  reportId?: string,
  options?: CustomUseQueryOptions<GetFailedInvoiceDeliveriesReportResponsePayload>,
) {
  const queryKey = queryKeys.failedInvoiceDeliveriesReport(reportId);
  const getFailedInvoiceDeliveriesReportQuery = useQuery(
    queryKey,
    async () => {
      const api = getPrivateApi();
      const getFailedInvoiceDeliveriesReportResponse = await api.getFailedInvoiceDeliveriesReport({
        reportId,
      });

      return GetFailedInvoiceDeliveriesReportResponseSchema.parse(getFailedInvoiceDeliveriesReportResponse);
    },
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(
    getFailedInvoiceDeliveriesReportQuery.data,
    'getFailedInvoiceDeliveriesReportQuery data',
  );

  return getFailedInvoiceDeliveriesReportQuery;
}
